var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Resource_1;
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ModuleType } from './moduleTypeResources';
// NOTE: importing BlueprintType/SolutionType from a copy stored in authorize domain instead of directly from solution domain to avoid ballooning auth.zip with solutions module (WP-8156)
// TOD0: investigate how to import directly from @symon-ai/wisepipe-solution-domain without bundleing in uncessary files.
// Authorize system resources
import { resourceSchema } from './jsonSchemas/resource';
import { resourceSchemaValidation } from '../validations.generated';
export const RESOURCE_ID_USERS = 'users';
export const RESOURCE_ID_ROLES = 'roles';
export const RESOURCE_ID_ORG = 'organization';
export const RESOURCE_ID_MODULE = 'modules';
export const RESOURCE_ID_ALL = '*'; // Pipe ID will not conflict with this
export const starterDashboardViewerResources = [
    ModuleType.Auth,
    ModuleType.Authorize,
    ModuleType.Computations,
    ModuleType.Dashboards,
    ModuleType.Data,
    ModuleType.Results,
    ModuleType.Subscriptions
];
export const authorizeDBModuleResources = [
    ModuleType.AuditLogs,
    ModuleType.Auth,
    ModuleType.Authorize,
    ModuleType.Computations,
    ModuleType.Connections,
    ModuleType.Dashboards,
    ModuleType.Data,
    ModuleType.Export,
    ModuleType.Pipes,
    ModuleType.Recommend,
    ModuleType.Results,
    ModuleType.ReusableLogics,
    ModuleType.Schedules,
    ModuleType.Solutions,
    ModuleType.Subscriptions
];
let Resource = Resource_1 = class Resource {
    constructor(resourceType, id, name, createdAt) {
        this.type = resourceType;
        this.id = id;
        this.name = name;
        this.createdAt = createdAt;
        JSON.validate(this, Resource_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], Resource.prototype, "createdAt", void 0);
Resource = Resource_1 = __decorate([
    JsonSchemaV2(resourceSchema, resourceSchemaValidation)
], Resource);
export { Resource };
//# sourceMappingURL=resource.js.map